import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Snackbar } from "@gf-easy-8/grmnext-foundation";
import useSnackBar, {
  SnackBar,
  offsetAnimation,
} from "provider/SnackBarProvider";

const SnackbarWrapperConatiner = styled.div`
  min-width: 400px;
  display: block;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 200;

  & > div > div {
    transform: initial;
    left: initial;
    top: initial;
    right: 40px;
    position: relative;
    margin: 20px 0 0 auto;
  }
`;
SnackbarWrapperConatiner.displayName = "SnackbarWrapperConatiner";

interface StyledSnackBarContainerProps {
  show: boolean;
}

const StyledSnackBarContainer = styled.div<StyledSnackBarContainerProps>`
  transition: opacity 0.5s;
  opacity: ${({ show }) => (show ? "1" : "0")};
`;
StyledSnackBarContainer.displayName = "StyledSnackBarContainer";

const SnackbarWrapper = () => {
  const { snackBarContext } = useSnackBar();
  const [snackBars, setSnackBars] = snackBarContext.snackBars;
  const { removeSnackBar } = snackBarContext.modify;

  const [savedInterval, setSavedInterval] = useState<any>();
  const [currentTime, setCurrentTime] = useState<number>(new Date().getTime());

  useEffect(() => {
    if (snackBars.length > 0) {
      if (savedInterval) {
        clearInterval(savedInterval);
      }
      const interval = setInterval(() => {
        const newCurrentTime = new Date().getTime();
        const filteredSnackBars = snackBars.filter(
          (snackBars: SnackBar) => snackBars.expiration > newCurrentTime
        );
        setCurrentTime(newCurrentTime);
        setSnackBars(filteredSnackBars);
      }, 1000);
      setSavedInterval(interval);
    }
    if (snackBars.length == 0) {
      setSavedInterval(null);
      clearInterval(savedInterval);
    }
  }, [snackBars]);

  return (
    <SnackbarWrapperConatiner>
      {snackBars &&
        snackBars.map((snackBar: SnackBar, index: number) => (
          <StyledSnackBarContainer
            show={snackBar.expiration - offsetAnimation > currentTime}
          >
            <Snackbar
              key={snackBar.expiration}
              message={snackBar.message}
              title={snackBar.title}
              snackbarType={snackBar.snackbarType!}
              onClose={() => {
                removeSnackBar(index);
              }}
            />
          </StyledSnackBarContainer>
        ))}
    </SnackbarWrapperConatiner>
  );
};

export default SnackbarWrapper;
